(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["system-utility"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.su-slider').forEach(function (slider) {
    const track = slider.querySelector('.su-track');
    const slides = Array.from(slider.querySelectorAll('.su-slide'));
    const prevBtn = slider.querySelector('.su-prev');
    const nextBtn = slider.querySelector('.su-next');
    const dotsWrap = slider.querySelector('.su-dots');
    if (!track || slides.length === 0) return;

    let index = 0;
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = (parseInt(slider.dataset.speed, 10) || 4) * 1000;
    let timer = null;

    slides.forEach(function (_, i) {
      const dot = document.createElement('button');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
    });
    const dots = Array.from(dotsWrap.children);

    function update() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
    }
    function goTo(i) {
      index = (i + slides.length) % slides.length;
      update();
      restart();
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    update();
    restart();
  });
});

  } catch(e) { console.error(e); }
})();
})();
